import { useQuery } from '@apollo/client'
import { ReactElement } from 'react'

import { SelectTags } from 'components/v2/SelectTags'
import { ISelectTagsProps } from 'components/v2/SelectTags/types'
import { GET_ROUTING_PROJECTS_TAGS } from 'features/RoutingProjects/queries'
import { defineMessages, useIntl } from 'react-intl'

const messages = defineMessages({
  emptyMessage: {
    id: 'routingProjects.tags.empty',
    defaultMessage: 'New tag will be created'
  }
})

interface ISelectRoutingProjectsTagsProps extends Omit<ISelectTagsProps, 'onChange' | 'items' | 'getTagLabel'> {
  onChange: (tags: string[]) => void
  values: string[]
}

export const SelectRoutingProjectsTags = ({
  onChange,
  label,
  placeholder,
  values,
  ...props
}: ISelectRoutingProjectsTagsProps): ReactElement => {
  const intl = useIntl()
  const { data, loading, error } = useQuery(GET_ROUTING_PROJECTS_TAGS, {
    fetchPolicy: 'network-only'
  })

  const shownItems = data?.routingProjectsTags?.tags.filter((tag) => !values.includes(tag)) || []

  const handleChange = (tags: string[]): void => {
    onChange(tags)
  }

  return (
    <SelectTags
      id="tags"
      values={values}
      onChange={handleChange}
      label={label}
      placeholder={placeholder}
      items={shownItems}
      getTagLabel={(tag: string): string => tag}
      enableNewTags
      loading={loading}
      error={error}
      emptyMessage={intl.formatMessage(messages.emptyMessage)}
      {...props}
    />
  )
}
